// Calling codes for every country, used by the phone-number field on Signup.
// Angola is the default (matches the site's primary market).
export const countryCodes = [
    { name: 'Afeganistão', dial: '+93' },
    { name: 'África do Sul', dial: '+27' },
    { name: 'Albânia', dial: '+355' },
    { name: 'Alemanha', dial: '+49' },
    { name: 'Andorra', dial: '+376' },
    { name: 'Angola', dial: '+244' },
    { name: 'Anguilla', dial: '+1264' },
    { name: 'Antígua e Barbuda', dial: '+1268' },
    { name: 'Arábia Saudita', dial: '+966' },
    { name: 'Argélia', dial: '+213' },
    { name: 'Argentina', dial: '+54' },
    { name: 'Armênia', dial: '+374' },
    { name: 'Austrália', dial: '+61' },
    { name: 'Áustria', dial: '+43' },
    { name: 'Azerbaijão', dial: '+994' },
    { name: 'Bahamas', dial: '+1242' },
    { name: 'Bahrein', dial: '+973' },
    { name: 'Bangladesh', dial: '+880' },
    { name: 'Barbados', dial: '+1246' },
    { name: 'Bélgica', dial: '+32' },
    { name: 'Belize', dial: '+501' },
    { name: 'Benin', dial: '+229' },
    { name: 'Bielorrússia', dial: '+375' },
    { name: 'Bolívia', dial: '+591' },
    { name: 'Bósnia e Herzegovina', dial: '+387' },
    { name: 'Botsuana', dial: '+267' },
    { name: 'Brasil', dial: '+55' },
    { name: 'Brunei', dial: '+673' },
    { name: 'Bulgária', dial: '+359' },
    { name: 'Burkina Faso', dial: '+226' },
    { name: 'Burundi', dial: '+257' },
    { name: 'Butão', dial: '+975' },
    { name: 'Cabo Verde', dial: '+238' },
    { name: 'Camarões', dial: '+237' },
    { name: 'Camboja', dial: '+855' },
    { name: 'Canadá', dial: '+1' },
    { name: 'Catar', dial: '+974' },
    { name: 'Cazaquistão', dial: '+7' },
    { name: 'Chade', dial: '+235' },
    { name: 'Chile', dial: '+56' },
    { name: 'China', dial: '+86' },
    { name: 'Chipre', dial: '+357' },
    { name: 'Colômbia', dial: '+57' },
    { name: 'Comores', dial: '+269' },
    { name: 'Congo-Brazzaville', dial: '+242' },
    { name: 'Congo-Kinshasa (RDC)', dial: '+243' },
    { name: 'Coreia do Norte', dial: '+850' },
    { name: 'Coreia do Sul', dial: '+82' },
    { name: 'Costa do Marfim', dial: '+225' },
    { name: 'Costa Rica', dial: '+506' },
    { name: 'Croácia', dial: '+385' },
    { name: 'Cuba', dial: '+53' },
    { name: 'Dinamarca', dial: '+45' },
    { name: 'Djibuti', dial: '+253' },
    { name: 'Dominica', dial: '+1767' },
    { name: 'Egito', dial: '+20' },
    { name: 'El Salvador', dial: '+503' },
    { name: 'Emirados Árabes Unidos', dial: '+971' },
    { name: 'Equador', dial: '+593' },
    { name: 'Eritreia', dial: '+291' },
    { name: 'Eslováquia', dial: '+421' },
    { name: 'Eslovênia', dial: '+386' },
    { name: 'Espanha', dial: '+34' },
    { name: 'Essuatíni', dial: '+268' },
    { name: 'Estados Unidos', dial: '+1' },
    { name: 'Estônia', dial: '+372' },
    { name: 'Etiópia', dial: '+251' },
    { name: 'Fiji', dial: '+679' },
    { name: 'Filipinas', dial: '+63' },
    { name: 'Finlândia', dial: '+358' },
    { name: 'França', dial: '+33' },
    { name: 'Gabão', dial: '+241' },
    { name: 'Gâmbia', dial: '+220' },
    { name: 'Gana', dial: '+233' },
    { name: 'Geórgia', dial: '+995' },
    { name: 'Granada', dial: '+1473' },
    { name: 'Grécia', dial: '+30' },
    { name: 'Guatemala', dial: '+502' },
    { name: 'Guiana', dial: '+592' },
    { name: 'Guiné', dial: '+224' },
    { name: 'Guiné-Bissau', dial: '+245' },
    { name: 'Guiné Equatorial', dial: '+240' },
    { name: 'Haiti', dial: '+509' },
    { name: 'Holanda (Países Baixos)', dial: '+31' },
    { name: 'Honduras', dial: '+504' },
    { name: 'Hungria', dial: '+36' },
    { name: 'Iêmen', dial: '+967' },
    { name: 'Índia', dial: '+91' },
    { name: 'Indonésia', dial: '+62' },
    { name: 'Irã', dial: '+98' },
    { name: 'Iraque', dial: '+964' },
    { name: 'Irlanda', dial: '+353' },
    { name: 'Islândia', dial: '+354' },
    { name: 'Israel', dial: '+972' },
    { name: 'Itália', dial: '+39' },
    { name: 'Jamaica', dial: '+1876' },
    { name: 'Japão', dial: '+81' },
    { name: 'Jordânia', dial: '+962' },
    { name: 'Kiribati', dial: '+686' },
    { name: 'Kosovo', dial: '+383' },
    { name: 'Kuwait', dial: '+965' },
    { name: 'Laos', dial: '+856' },
    { name: 'Lesoto', dial: '+266' },
    { name: 'Letônia', dial: '+371' },
    { name: 'Líbano', dial: '+961' },
    { name: 'Libéria', dial: '+231' },
    { name: 'Líbia', dial: '+218' },
    { name: 'Liechtenstein', dial: '+423' },
    { name: 'Lituânia', dial: '+370' },
    { name: 'Luxemburgo', dial: '+352' },
    { name: 'Macedônia do Norte', dial: '+389' },
    { name: 'Madagáscar', dial: '+261' },
    { name: 'Malásia', dial: '+60' },
    { name: 'Malawi', dial: '+265' },
    { name: 'Maldivas', dial: '+960' },
    { name: 'Mali', dial: '+223' },
    { name: 'Malta', dial: '+356' },
    { name: 'Marrocos', dial: '+212' },
    { name: 'Marshall (Ilhas)', dial: '+692' },
    { name: 'Maurícia', dial: '+230' },
    { name: 'Mauritânia', dial: '+222' },
    { name: 'México', dial: '+52' },
    { name: 'Mianmar', dial: '+95' },
    { name: 'Micronésia', dial: '+691' },
    { name: 'Moçambique', dial: '+258' },
    { name: 'Moldávia', dial: '+373' },
    { name: 'Mônaco', dial: '+377' },
    { name: 'Mongólia', dial: '+976' },
    { name: 'Montenegro', dial: '+382' },
    { name: 'Namíbia', dial: '+264' },
    { name: 'Nauru', dial: '+674' },
    { name: 'Nepal', dial: '+977' },
    { name: 'Nicarágua', dial: '+505' },
    { name: 'Níger', dial: '+227' },
    { name: 'Nigéria', dial: '+234' },
    { name: 'Noruega', dial: '+47' },
    { name: 'Nova Zelândia', dial: '+64' },
    { name: 'Omã', dial: '+968' },
    { name: 'Palau', dial: '+680' },
    { name: 'Panamá', dial: '+507' },
    { name: 'Papua-Nova Guiné', dial: '+675' },
    { name: 'Paquistão', dial: '+92' },
    { name: 'Paraguai', dial: '+595' },
    { name: 'Peru', dial: '+51' },
    { name: 'Polônia', dial: '+48' },
    { name: 'Portugal', dial: '+351' },
    { name: 'Quênia', dial: '+254' },
    { name: 'Quirguistão', dial: '+996' },
    { name: 'Reino Unido', dial: '+44' },
    { name: 'República Centro-Africana', dial: '+236' },
    { name: 'República Dominicana', dial: '+1809' },
    { name: 'República Tcheca', dial: '+420' },
    { name: 'Romênia', dial: '+40' },
    { name: 'Ruanda', dial: '+250' },
    { name: 'Rússia', dial: '+7' },
    { name: 'Salomão (Ilhas)', dial: '+677' },
    { name: 'Samoa', dial: '+685' },
    { name: 'San Marino', dial: '+378' },
    { name: 'Santa Lúcia', dial: '+1758' },
    { name: 'São Cristóvão e Nevis', dial: '+1869' },
    { name: 'São Tomé e Príncipe', dial: '+239' },
    { name: 'São Vicente e Granadinas', dial: '+1784' },
    { name: 'Seicheles', dial: '+248' },
    { name: 'Senegal', dial: '+221' },
    { name: 'Serra Leoa', dial: '+232' },
    { name: 'Sérvia', dial: '+381' },
    { name: 'Singapura', dial: '+65' },
    { name: 'Síria', dial: '+963' },
    { name: 'Somália', dial: '+252' },
    { name: 'Sri Lanka', dial: '+94' },
    { name: 'Sudão', dial: '+249' },
    { name: 'Sudão do Sul', dial: '+211' },
    { name: 'Suécia', dial: '+46' },
    { name: 'Suíça', dial: '+41' },
    { name: 'Suriname', dial: '+597' },
    { name: 'Tailândia', dial: '+66' },
    { name: 'Taiwan', dial: '+886' },
    { name: 'Tajiquistão', dial: '+992' },
    { name: 'Tanzânia', dial: '+255' },
    { name: 'Timor-Leste', dial: '+670' },
    { name: 'Togo', dial: '+228' },
    { name: 'Tonga', dial: '+676' },
    { name: 'Trinidad e Tobago', dial: '+1868' },
    { name: 'Tunísia', dial: '+216' },
    { name: 'Turcomenistão', dial: '+993' },
    { name: 'Turquia', dial: '+90' },
    { name: 'Tuvalu', dial: '+688' },
    { name: 'Ucrânia', dial: '+380' },
    { name: 'Uganda', dial: '+256' },
    { name: 'Uruguai', dial: '+598' },
    { name: 'Uzbequistão', dial: '+998' },
    { name: 'Vanuatu', dial: '+678' },
    { name: 'Vaticano', dial: '+379' },
    { name: 'Venezuela', dial: '+58' },
    { name: 'Vietnã', dial: '+84' },
    { name: 'Zâmbia', dial: '+260' },
    { name: 'Zimbábue', dial: '+263' },
];
